"use client";

// Раскрытие высотой (№22 каталога движения).
//
// ЗАЧЕМ. Вложенные строки в ассортименте, сводных таблицах и приёмках
// раскрывались мгновенным прыжком: всё, что под ними, скакало вниз, и взгляд
// терял строку, по которой только что кликнули. Здесь высота едет за 340 мс.
//
// ⚠️ ПОЧЕМУ GRID, А НЕ max-height. Приём с max-height требует угадать предел:
// занизил — содержимое обрежется, завысил — раскрытие «залипает» на паузу,
// пока фиктивная высота доезжает до реальной. `grid-template-rows: 0fr → 1fr`
// анимирует РЕАЛЬНУЮ высоту содержимого, сколько бы её ни было.
//
// ⚠️ ПОЧЕМУ ДЕТЕЙ ДЕРЖИМ ПОСЛЕ ЗАКРЫТИЯ. Если размонтировать их сразу, схлопывание
// анимируется впустую — коробка пустая, и раскрытие выглядит односторонним.
// Держим ещё 340 мс, ровно на время анимации, и только потом отпускаем: тяжёлое
// содержимое (панель поставщиков внутри строки) не висит в памяти у всех строк.

import { useEffect, useRef, useState, type ReactNode } from "react";

const DURATION_MS = 340;

export function Collapse({ open, children }: { open: boolean; children: ReactNode }) {
  const [mounted, setMounted] = useState(open);
  // `shown` — это и есть data-open. Отдельно от `open`, потому что при РАСКРЫТИИ
  // он поднимается на кадр позже: см. ниже.
  const [shown, setShown] = useState(open);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (timer.current) clearTimeout(timer.current);
    if (open) {
      setMounted(true);
      // ⚠️ ЗАЧЕМ ДВА КАДРА. Раньше коробка появлялась сразу с data-open="1":
      // начального значения 0fr браузер никогда не видел, анимировать было не от
      // чего — раскрытие происходило мгновенным прыжком, а схлопывание
      // анимировалось. Ждём, пока раскладка с 0fr будет посчитана, и только
      // потом поднимаем флаг (Максим, 26.08.2026).
      let inner = 0;
      const outer = requestAnimationFrame(() => { inner = requestAnimationFrame(() => setShown(true)); });
      return () => { cancelAnimationFrame(outer); if (inner) cancelAnimationFrame(inner); };
    }
    setShown(false);
    timer.current = setTimeout(() => setMounted(false), DURATION_MS);
    return () => { if (timer.current) clearTimeout(timer.current); };
  }, [open]);

  if (!mounted && !open) return null;

  return (
    <div className="collapse-grid" data-open={shown ? "1" : "0"}>
      <div className="collapse-clip">{children}</div>
    </div>
  );
}
